import { render, staticRenderFns } from "./FooterSection.vue?vue&type=template&id=7ed19048"
var script = {}
import style0 from "@/css/Footer/footerLc.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports